import styled from 'styled-components';
import { DatePicker as AntDatePicker } from 'antd';
import { theme } from 'modules/ui';
import { StyledInputWithLabel } from '../inputWithLabel/styled';
import { IconsWrapper } from '../input/styled';

export const StyledAntDatePicker = styled(AntDatePicker)<{
  $disabled: boolean;
}>`
  width: 100%;

  // input field changes
  input {
    ${(props) =>
      props.$disabled
        ? `
            color: ${props.theme.colors.primaryK10};
            &:hover {
              color: ${props.theme.colors.primaryK10}
            }
          `
        : 'cursor: pointer;'}
  }
  &,
  .ant-picker-input {
    padding: 0;
    border: none;
    outline: none;
    box-shadow: none;
  }

  .ant-picker-suffix {
    position: absolute;
    right: 0;
    top: 1.925rem;
    margin-right: 0.5rem;
    &:hover {
      opacity: 0.9;
    }

    ${(props) =>
      props.$disabled
        ? `g, path {
          fill: ${props.theme.colors.primaryK3};
        }`
        : ''}
  }

  // remove borders
  .ant-picker-header,
  .ant-picker-footer {
    border: none;
  }

  // fonts
  .ant-picker-header {
    font-size: ${theme.fontSizes.h2};
    line-height: var(--h2-line-height);
    font-weight: ${theme.fontWeight.bold};
    padding: 1rem 0.8rem 0.5rem 0.8rem;
    & button {
      color: ${({theme}) => theme.colors.primaryK10};
      &:hover {
        color: ${({theme}) => theme.colors.primaryK7};
      }
    }
  }
  .ant-picker-cell .ant-picker-cell-inner {
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.fontSizes.h5};
    height: 1.938rem;
    min-width: 1.938rem;
    line-height: 1.938rem;
  }

  // today button
  .ant-picker-today-btn {
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.fontSizes.h5};
    line-height: 0.938rem;
    text-transform: uppercase;
    color: ${({theme}) => theme.colors.primaryT2};
    &:hover {
      color: ${({theme}) => theme.colors.primaryT1};
    }
  }
  // calendar border
  .ant-picker-panel-container {
    border: 1px solid ${({theme}) => theme.colors.primaryK4};
    box-shadow: none;
  }
  // today marker
  .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border: 1px solid ${({theme}) => theme.colors.primaryK10};
    border-radius: 999px;
  }
  // hover over dates, selected date
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: ${({theme}) => theme.colors.primaryT2};
    border-radius: 999px;
  }
  .ant-picker-cell:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
  .ant-picker-cell:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end)
    .ant-picker-cell-inner {
    border-radius: 999px;
  }

  ${IconsWrapper} {
    margin-right: 2.5rem;
  }
`;

export const StyledAntDatePickerWrapper = styled(StyledInputWithLabel)`
  margin-bottom: 0;
`;
